import { Component, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Notification } from '../../models/Notification';
import * as NotificationActions from '../../state/notification/notification.actions';
import { selectAllNotifications } from '../../state/notification/notification.selectors';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { PageHeaderComponent } from '../page-header/page-header.component';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css',
  standalone: true,
  imports: [MatIconModule, CommonModule, RouterLink, MatButtonModule, PageHeaderComponent]
})
export class NotificationsComponent implements OnInit {
  notifications$: Observable<Notification[]>;

  constructor(private store: Store) {
    this.notifications$ = this.store.pipe(select(selectAllNotifications));
  }

  ngOnInit(): void {
    this.store.dispatch(NotificationActions.loadNotificationsForCustomer());
  }

  markAsRead(note: Notification) {
    if (!note.isRead) {
      this.store.dispatch(NotificationActions.markAsRead({ id: note.id }));
    }
  }

  onMarkAsRead(event: Event, note: Notification): void {
    event.preventDefault();
    event.stopPropagation();
    this.markAsRead(note);
  }
}
